import { COU_httpGet, COU_httpPost } from '@/utils/http'

// 修改预设属性
async function UpdatePresetProperty(preSetProperty) {
  const url = 'shopSetting/modifyPreSetProperty'
  const data = { preSetProperty: JSON.stringify(preSetProperty) }
  const r = await COU_httpPost({ url, data })
  let msg = '', success = false
  try {
    msg = r.msg
    success = r.success
  } 
  catch (error) {
    console.log(error)
  }
  if (!msg) msg = '修改预设属性失败'
  return { msg, success }
}

// 获取已设置的预设属性列表
async function GetAttributePreset() {
  const url = '/shopSetting/goodPublishSetting'
  const r = await COU_httpGet({ url })
  let result = {}, list = [], msg = '', success = false
  try {
    msg = r.msg
    success = r.success
    result = r.result.PreSetProperty
  } 
  catch (error) {
    console.log(error)
  }
  if (!result) list = []
  else {
    result = JSON.parse(result)
    for (let key in result) {
      list.push({
        name: key, value: result[key]
      })
    }
  }
  return { list, msg, success }
}

export { UpdatePresetProperty, GetAttributePreset }